import { render, staticRenderFns } from "./AdditionalHolidays_Create.vue?vue&type=template&id=45360a1b&scoped=true"
import script from "./AdditionalHolidays_Create.vue?vue&type=script&lang=js"
export * from "./AdditionalHolidays_Create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45360a1b",
  null
  
)

export default component.exports